// IntakeCtaWidget — Advice-firm Home banner pushing the New Client Intake
// wizard front and centre. Renders null for non-advice orgs so it is safe
// even if added to another layout.

import { Button } from '@/components/ui/button';
import { UserPlus, Sparkles, ArrowRight } from 'lucide-react';

export default function IntakeCtaWidget({ ctx }) {
  if (ctx?.orgType !== 'advice') return null;
  return (
    <div className="rounded-xl border border-[#E6E0D9] bg-gradient-to-r from-[#FAF5F0] to-[#F5EDE5] p-5 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="intake-cta-widget">
      <div className="w-12 h-12 rounded-xl bg-[#A86A3A] flex items-center justify-center shrink-0">
        <UserPlus className="w-5 h-5 text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-heading text-base text-[#2C2420] mb-1 flex items-center gap-2">
          New Client Intake
          <Sparkles className="w-3.5 h-3.5 text-[#A86A3A]" />
        </h3>
        <p className="text-sm text-[#5D524D]">
          Paste a referral email or notes — AI pre-fills individuals, entities and advisers in a guided 5-step wizard.
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Button
          onClick={() => ctx?.setShowClientIntake?.(true)}
          className="bg-[#A86A3A] hover:bg-[#8B5730] text-white"
          data-testid="intake-cta-start-btn"
        >
          Start intake <ArrowRight className="w-3.5 h-3.5 ml-1.5" />
        </Button>
        <Button
          variant="ghost"
          onClick={() => ctx?.setShowQuickCapture?.(true)}
          className="text-[#5D524D]"
          data-testid="intake-cta-quick-task-btn"
        >
          Quick task
        </Button>
      </div>
    </div>
  );
}
